<template>
    <div
        class="overflow-hidden rounded-[12.8px] border border-amber-200 bg-amber-50"
    >
        <div class="px-6 py-8">
            <div class="text-center">
                <div class="text-amber-600">
                    <svg
                        class="mx-auto h-12 w-12"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                    </svg>
                </div>
                <h3 class="mt-4 text-lg font-medium text-amber-900">
                    {{ title }}
                </h3>
                <p
                    class="mt-2 text-sm text-amber-800 max-w-md mx-auto leading-relaxed"
                >
                    {{ description }}
                </p>
                <div class="mt-6">
                    <inertia-link
                        class="cursor-pointer"
                        :href="route('billing.subscriptions.index')"
                    >
                        <AtomicButton
                            color="yellow"
                            size="md"
                            class="cursor-pointer"
                        >
                            Upgrade Subscription
                        </AtomicButton>
                    </inertia-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import route from "ziggy-js";

interface Props {
    title?: string;
    description?: string;
}

withDefaults(defineProps<Props>(), {
    title: "Upgrade Required",
    description:
        "You don't have access to this section because your trial has expired or your current plan doesn't include this feature. To continue using detailed DMARC reports and analytics, please upgrade your subscription.",
});
</script>
